var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckDropped = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#2BA18D",
  rx: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M26.025 30c-1.4 0-2.587-.483-3.563-1.45C21.488 27.583 21 26.4 21 25s.488-2.583 1.462-3.55c.976-.967 2.163-1.45 3.563-1.45 1.383 0 2.558.488 3.525 1.462.967.976 1.45 2.155 1.45 3.538s-.483 2.563-1.45 3.538c-.967.974-2.142 1.462-3.525 1.462ZM12 26v-8 .325V14v12Zm0-10h16v-2H12v2Zm0 12c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 10 26V14c0-.55.196-1.02.588-1.412A1.926 1.926 0 0 1 12 12h16c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v3.95c0 .3-.13.52-.387.663-.259.141-.53.145-.813.012A7.01 7.01 0 0 0 25.9 18c-.95 0-1.846.18-2.688.538A7.156 7.156 0 0 0 21 20h-9v6h6.575c.283 0 .52.096.713.288.191.191.287.429.287.712s-.096.52-.287.712a.968.968 0 0 1-.713.288H12Zm14.5-3.2v-2.3a.48.48 0 0 0-.15-.35.48.48 0 0 0-.7 0 .48.48 0 0 0-.15.35v2.275c0 .133.025.263.075.388.05.125.125.237.225.337l1.525 1.525a.48.48 0 0 0 .7 0 .48.48 0 0 0 0-.7L26.5 24.8Z"
})));
SvgCheckDropped.viewBox = '0 0 40 40';
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckDropped);
export default ForwardRef;